// Custom pricing validation shared by the booking drawer pricing views and the
// schedule slot pricing editor. Rules mirror EditPricingView.validatePricing():
// category name required; max >= min and > 0 when set; min and default
// required; default within [min, max]; every tier needs a price and a valid
// min <= max range.
//
// Values may arrive as strings (schedule slots hydrate from JSON), so numbers
// are coerced first: '' / null / undefined count as "empty".

function num(v) {
  if (v === '' || v === null || v === undefined) return NaN
  return Number(v)
}

export function validateSlotPricing({ enabled, categories }) {
  const errors = {}
  let valid = true
  if (!enabled) return { valid: true, errors }

  const cats = Array.isArray(categories) ? categories : []
  for (let i = 0; i < cats.length; i++) {
    const cat = cats[i]
    const catErrs = {}

    if (!cat.category || !String(cat.category).trim()) {
      catErrs.category = 'Category cannot be empty'
    }

    const min = num(cat.minimum_participants)
    const max = num(cat.maximum_participants)
    const def = num(cat.default_participants)

    if (Number.isFinite(max) && Number.isFinite(min) && max < min) {
      catErrs.maximum_participants = 'Maximum participants cannot be less than minimum participants'
    } else if (Number.isFinite(max) && max <= 0) {
      catErrs.maximum_participants = 'Maximum participants cannot be 0 or less'
    }

    if (!Number.isFinite(min)) {
      catErrs.minimum_participants = 'Minimum participants cannot be empty'
    }

    if (!Number.isFinite(def)) {
      catErrs.default_participants = 'Default participants cannot be empty'
    } else if (Number.isFinite(min) && def < min) {
      catErrs.default_participants = 'Default participants cannot be less than minimum participants'
    } else if (Number.isFinite(max) && def > max) {
      catErrs.default_participants = 'Default participants cannot be greater than maximum participants'
    }

    const tierErrs = {}
    const tiers = Array.isArray(cat.pricing) ? cat.pricing : []
    for (let j = 0; j < tiers.length; j++) {
      const tier = tiers[j]
      const te = {}
      const price = num(tier.price)
      const tMin = num(tier.min_players)
      const tMax = num(tier.max_players)

      if (!Number.isFinite(price)) te.price = 'Price cannot be empty'

      if (!Number.isFinite(tMax)) {
        te.max_players = 'Invalid value'
      } else if (Number.isFinite(tMin) && tMax < tMin) {
        te.max_players = 'Invalid range'
        te.min_players = 'Invalid range'
      }

      if (!Number.isFinite(tMin)) {
        te.min_players = 'Invalid value'
      } else if (Number.isFinite(tMax) && tMax < tMin) {
        te.max_players = 'Invalid range'
        te.min_players = 'Invalid range'
      }

      if (Object.keys(te).length > 0) tierErrs[j] = te
    }
    if (Object.keys(tierErrs).length > 0) catErrs.tiers = tierErrs

    if (Object.keys(catErrs).length > 0) {
      errors[i] = catErrs
      valid = false
    }
  }

  return { valid, errors }
}
